import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import About from '../views/About.vue'
import Home from '../views/Home.vue'
import Orders from "../views/Orders"
import Testversion from "../views/Testversion";


Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        component: Home,
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Dashboard,
                auth: true
            },
            {
                path: 'testversion',
                name: 'testversion',
                component: Testversion,
                auth: true
            }, {
                path: 'bestellungen',
                name: 'bestellungen',
                component: Orders,
                auth: true
            }, {
                path: 'about',
                name: 'about',
                component: About,
                auth: true
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        props: (route) => ({query: route.query.baseUrl}),
        component: Login
    }
]


const router = new VueRouter({
    routes
})

export default router


